import { Checkbox, Col, Divider, Form, FormInstance } from 'antd';
import { useIntl } from 'react-intl';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import InvoiceCheckBoxs from './InvoiceCheckBoxs';
import InvoiceMoreOptions from './InvoiceMoreOptions';
import { QuestReportInvoiceFormValues } from '@/core/domain/questReport/Reports/Invoice/Invoice.types';

interface Props {
  form: FormInstance<QuestReportInvoiceFormValues>;
}

const InvoiceForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();

  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields form={form} />

      <InvoiceCheckBoxs />

      <Col>
        <Form.Item
          noStyle
          name="detailItems"
          initialValue={false}
          valuePropName="checked"
        >
          <Checkbox>
            {intl.formatMessage({
              id: 'report.invoice.form.detailTheInvoiceItems',
            })}
          </Checkbox>
        </Form.Item>
      </Col>

      <Col>
        <Form.Item
          noStyle
          name="disregardWithheldIss"
          initialValue={false}
          valuePropName="checked"
        >
          <Checkbox>
            {intl.formatMessage({
              id: 'report.invoice.form.disregardWithheldIss',
            })}
          </Checkbox>
        </Form.Item>
      </Col>

      <Divider />

      <InvoiceMoreOptions form={form} />
    </Form>
  );
};

export default InvoiceForm;
